export default __webpack_public_path__ + "static/media/outgoingcall.193da33e.wav";